import {AudioPlayer} from './Audio.js'

// AudioPlaylist handling class
export class AudioPlaylist {

	constructor() {
		this.audio = new AudioPlayer();
		this.repeatTimer = false;
		this.playlist = [];
		this.currentEl = false;
	}

	add(file, repeat, repeatDelay, callback, triggerLastClickUpdate) {
		repeat = (typeof repeat != "undefined") ? repeat : false;
		repeatDelay = (typeof repeatDelay != "undefined") ? repeatDelay : false;
		callback = (typeof callback != "undefined") ? callback : false;
		triggerLastClickUpdate = typeof triggerLastClickUpdate !== "undefined" ? triggerLastClickUpdate : false;

		this.playlist.push({
			file: file,
			repeat: repeat,
			repeatDelay: repeatDelay,
			callback: callback,
			triggerLastClickUpdate: triggerLastClickUpdate,
		})
	}

	play() {
		if (this.playlist.length > 0) {
			this.currentEl = this.audio.play(this.playlist[0].file, 1.0, true, $.proxy(this.onFileEnd, this), this.playlist[0].triggerLastClickUpdate).el;
			// $(this.currentEl).one("ended", $.proxy(this.onFileEnd, this));
		}
	}

	onFileEnd() {

		// Save callback before clearing element
		var callback = (typeof this.playlist[0].callback == "function") ? this.playlist[0].callback : false;

		$(this.currentEl).off();
		this.currentEl = false;

		if (this.playlist[0].repeat == false) {
			this.playlist.shift();
			this.play();
		} else if (this.playlist[0].repeat == true) {
			if (this.repeatTimer != false) {
				clearTimeout(this.repeatTimer);
				this.repeatTimer = false;
			}
			this.repeatTimer = setTimeout($.proxy(function () {
				this.play();
			}, this), this.playlist[0].repeatDelay);
		}

		// Trigger callback
		if (callback) {
			callback();
		}
	}

	clear() {

		while (this.playlist.length > 1) {
			this.playlist.pop();
		}

		if (this.currentEl != false) {
			this.currentEl.pause();
			$(this.currentEl).off();
			this.currentEl = false;
		}
		if (this.repeatTimer != false) {
			clearTimeout(this.repeatTimer);
			this.repeatTimer = false;
		}

		this.audio.clearAll()

		this.playlist = [];
	}

}
